// Get saved data from sessionStorage
export function getItem(key: string): string | null {
    return window.sessionStorage.getItem(key)
}

// Remove saved data from sessionStorage
export function removeItem(key: string): void {
    window.sessionStorage.removeItem(key)
}

// Save data to sessionStorage
// Do not store sensitive data in sessionStorage
export const setItem = (key: string, value: string): void => {
    window.sessionStorage.setItem(key, value)
}

// Clear sessionStorage
export const clear = (): void => {
    window.sessionStorage.clear()
}

export default {
    getItem,
    removeItem,
    setItem,
    clear,
}
